import { Close } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import BriaButton from "../../../components/common/BriaButton/BriaButton.tsx";
import { POSTHOG_EVENTS } from "../../../constants/PostHogEvents";
import { usePostHog } from "../../../hooks/usePostHog";
import { getFiboLabVariant } from "../../../utils";
import styles from "./TryRefinePopup.module.scss";

interface IProps {
	onClick: () => void;
	onClose: () => void;
}

export default function LearnMorePopup({ onClick, onClose }: IProps) {
	const { t } = useTranslation("fibo", { keyPrefix: "lab.tryRefine" });
	const { trackEvent } = usePostHog();
	const labVariant = getFiboLabVariant();

	// Track popup opened
	useEffect(() => {
		if (labVariant) {
			trackEvent(POSTHOG_EVENTS.FIBO_TRY_REFINE_POPUP_OPENED, {
				lab_variant: labVariant,
			});
		}
	}, [labVariant, trackEvent]);

	const handleClick = () => {
		if (labVariant) {
			trackEvent(POSTHOG_EVENTS.FIBO_TRY_REFINE_POPUP_CLICKED, {
				lab_variant: labVariant,
			});
		}
		onClick();
	};

	const handleClose = () => {
		if (labVariant) {
			trackEvent(POSTHOG_EVENTS.FIBO_TRY_REFINE_POPUP_CLOSED, {
				lab_variant: labVariant,
			});
		}
		onClose();
	};

	return (
		<Box className={styles.tryRefineContainer}>
			<IconButton onClick={handleClose} className={styles.closeButton} size="small">
				<Close />
			</IconButton>
			<Typography className={styles.title}>{t("title")}</Typography>
			<Typography className={styles.description}>{t("description")}</Typography>
			<BriaButton className={styles.button} buttonType="primaryMedium" onClick={handleClick} size="small">
				{t("button")}
			</BriaButton>
		</Box>
	);
}
